import React, { useState, useEffect } from "react";
import { Save, X } from "lucide-react";
import { Button } from "views/components/ui/Button";
import { Input } from "views/components/ui/Input";
import { Label } from "views/components/ui/Label";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "actions/category";

const ToolSubmitForm = ({ onSubmit, onCancel }) => {
    const dispatch = useDispatch();
    const { categories } = useSelector((state) => state.category);
    const [formData, setFormData] = useState({
        name: "",
        externalUrl: "",
        categoryId: "",
        subCategoryId: "",
        launchDate: new Date().toISOString().split("T")[0],
    });
    const [selectedCategoryId, setSelectedCategoryId] = useState("");
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");

    useEffect(() => {
        dispatch(fetchCategories());
    }, [dispatch]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleCategoryChange = (categoryId) => {
        setSelectedCategoryId(categoryId);
        setSelectedSubCategoryId("");
        setFormData((prev) => ({
            ...prev,
            categoryId: categoryId,
            subCategoryId: "",
        }));
    };

    const handleSubCategoryChange = (subCategoryId) => {
        setSelectedSubCategoryId(subCategoryId);
        setFormData((prev) => ({
            ...prev,
            subCategoryId: subCategoryId,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className="bg-white rounded-lg p-6">
            <div className="mb-6">
                <h2 className="text-2xl font-bold text-gray-900">
                    Submit New Tool
                </h2>
                <p className="text-gray-600 mt-2">
                    Enter the tool details to submit a new tool to the platform.
                </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
                <div className="space-y-2">
                    <Label htmlFor="name">Tool Name</Label>
                    <Input
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Enter tool name"
                        required
                    />
                </div>

                <div className="space-y-2">
                    <Label htmlFor="externalUrl">Tool URL</Label>
                    <Input
                        id="externalUrl"
                        name="externalUrl"
                        type="url"
                        value={formData.externalUrl}
                        onChange={handleInputChange}
                        placeholder="https://example.com"
                        required
                    />
                </div>

                <div className="flex justify-end gap-4">
                    <Button
                        type="button"
                        variant="outline"
                        onClick={onCancel}
                        className="flex items-center gap-2"
                    >
                        <X className="h-4 w-4" />
                        Cancel
                    </Button>
                    <Button type="submit" className="flex items-center gap-2">
                        <Save className="h-4 w-4" />
                        Submit Tool
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default ToolSubmitForm;
